<template>
  <div class="chat-widget audio-widget d-flex" :class="type === 'ai' ? 'ai-audio' : 'user-audio'" :style="type === 'ai' ? `background: ${config.response_color}` : `background: ${config.main_color}`">
    <audio :id="uuid" preload="auto" crossorigin="anonymous"><source :src="audio_url" type="audio/mp3" /></audio>

    <!-- play button -->
    <v-btn class="play-btn mr-2" :color="type === 'ai' ? config.response_text_color : config.text_color" variant="falt" @click="togglePlayPause()" aria-label="audio-play-btn">
      <v-icon v-if="is_playing">mdi-pause-circle</v-icon>
      <v-icon v-else>mdi-play-circle</v-icon>
    </v-btn>

    <!-- progress bar -->
    <!-- <v-slider
      v-model="current_time"
      @click="seekAudio"
      min="0"
      :max="duration"
      step="0.1"
      class="audio-bar"
      :color="type === 'ai' ? config.response_text_color : config.text_color"
      track-color="rgba(0, 0, 0, 0.3)"
      hide-details
    /> -->
    <input
      @click="seekAudio"
      @change="seekAudio"
      :class="type === 'ai' ? 'response_text_color' : 'text_color'"
      v-model="current_time"
      type="range"
      step="0.1"
      min="0"
      :max="duration.toFixed(1)"
      aria-label="audio-input"
    />
    <span class="ml-4 audio_duration" :style="type === 'ai' ? `color:${config.response_text_color}` : `color:${config.text_color}`">{{ formattedDuration }}</span>
  </div>
</template>

<script setup>
// global config
import global_config from '@/../config.json'
import { ref, computed, defineProps, onMounted, onUnmounted } from 'vue'

// Props
const { uuid, type, audio_url } = defineProps({ uuid: Number, type: String, audio_url: String })

// Data
const config = ref(global_config)
const is_playing = ref(false)
const duration = ref(0)
const current_time = ref(0)
const audio = ref()

// computed
const formattedDuration = computed(() => {
  return formatTime(duration.value)
})

// Methods
const formatTime = (time_in_seconds) => {
  const pad = (num, size) => ('000' + num).slice(size * -1)

  const time = parseFloat(time_in_seconds).toFixed(3)
  const minutes = Math.floor(time / 60) % 60
  const seconds = Math.floor(time - minutes * 60)

  return pad(minutes, 2) + ':' + pad(seconds, 2)
}
const initAudio = async () => {
  audio.value = document.getElementById(uuid)
  // TTS
  if (audio_url.startsWith('https') || audio_url.startsWith('http')) {
    const blob = await fetch(audio_url).then((resp) => resp.blob())
    audio.value.src = URL.createObjectURL(blob)
  }
  // Internal recording
  else {
    audio.value.src = audio_url
    setTimeout(() => {
      audio.value.currentTime = 0 // to reset the time, so it starts at the beginning
      duration.value = audio.value.duration
    })
  }

  audio.value.addEventListener('loadedmetadata', () => {
    duration.value = audio.value.duration
  })

  audio.value.addEventListener('timeupdate', () => {
    current_time.value = Math.round(audio.value.currentTime * 10) / 10

    if (audio.value.currentTime >= audio.value.duration) is_playing.value = false
  })
}
const togglePlayPause = () => {
  if (audio.value.paused) {
    audio.value.play()
    is_playing.value = true
  } else {
    audio.value.pause()
    is_playing.value = false
  }
}
const seekAudio = () => {
  audio.value.currentTime = current_time.value
}
onMounted(() => {
  initAudio()
})
onUnmounted(() => {
  audio.value.removeEventListener('loadedmetadata', initAudio)
  audio.value.removeEventListener('timeupdate', seekAudio)
})
// export default {
//   name: 'Audio',
//   props: { uuid: Number, type: String, audio_url: String },
//   data() {
//     return {
//       config: global_config,

//       is_playing: false,
//       duration: 0,
//       current_time: 0
//     }
//   },
//   computed: {
//     formattedDuration() {
//       return this.formatTime(this.duration)
//     }
//   },
//   methods: {
//     formatTime(time_in_seconds) {
//       const pad = (num, size) => ('000' + num).slice(size * -1)

//       const time = parseFloat(time_in_seconds).toFixed(3)
//       const minutes = Math.floor(time / 60) % 60
//       const seconds = Math.floor(time - minutes * 60)

//       return pad(minutes, 2) + ':' + pad(seconds, 2)
//     },
//     async initAudio() {
//       this.audio = document.getElementById(this.uuid)

//       // TTS
//       if (this.audio_url.startsWith('https') || this.audio_url.startsWith('http')) {
//         const blob = await fetch(this.audio_url).then((resp) => resp.blob())
//         this.audio.src = URL.createObjectURL(blob)
//       }
//       // Internal recording
//       else {
//         this.audio.src = this.audio_url
//         setTimeout(() => {
//           this.audio.currentTime = 0 // to reset the time, so it starts at the beginning
//           this.duration = this.audio.duration
//         })
//       }

//       this.audio.addEventListener('loadedmetadata', () => {
//         this.duration = this.audio.duration
//       })

//       this.audio.addEventListener('timeupdate', () => {
//         this.current_time = Math.round(this.audio.currentTime * 10) / 10

//         if (this.audio.currentTime >= this.audio.duration) this.is_playing = false
//       })
//     },
//     togglePlayPause() {
//       if (this.audio.paused) {
//         this.audio.play()
//         this.is_playing = true
//       } else {
//         this.audio.pause()
//         this.is_playing = false
//       }
//     },
//     seekAudio() {
//       this.audio.currentTime = this.current_time
//     }
//   },
//   mounted() {
//     this.initAudio()
//   },
//   beforeDestroy() {
//     this.audio.removeEventListener('loadedmetadata', this.initAudio)
//     this.audio.removeEventListener('timeupdate', this.seekAudio)
//   }
// }
</script>

<style scope>
.audio-widget {
  max-width: 16.5rem !important;
  padding: 0.75rem;
  flex-direction: row;
  align-items: center;
}

.ai-audio {
  background: #f0f0f0;
  border-radius: 0px 1rem 1rem 1rem;
}

.user-audio {
  background: #e22925;
  border-radius: 1rem 0px 1rem 1rem;
}

.v-btn.play-btn {
  height: 2rem !important;
  width: 2rem !important;
  min-width: fit-content;
  padding: 0;
}

.audio-bar {
  width: 16.5rem !important;
  margin: 0 0.5rem;
  align-items: center;
}

.v-slider__track-container {
  height: 0.25rem !important;
  border-radius: 0.25rem !important;
}

.audio_duration {
  font-weight: 400;
  font-size: 0.8125rem;
  line-height: 140%;
}

input[type='range'] {
  -webkit-appearance: none;
  appearance: none;
  width: 143px;
  height: 4px;
  background-color: rgba(0, 0, 0, 0.3);
  accent-color: #fff;
}

input[type='range'].text_color::-webkit-slider-thumb {
  width: 12px;
  height: 12px;
  background: #fff;
  cursor: pointer;
  border-radius: 50%;
}

input[type='range'].response_text_color::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 12px;
  height: 12px;
  background: #242428;
  cursor: pointer;
  border-radius: 50%;
}
</style>
